import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsHoldFinSizeS from './IconToolsHoldFin_size_s';

const props: CreateIconArguments = {
  l: IconToolsHoldFinSizeS,
  m: IconToolsHoldFinSizeS,
  s: IconToolsHoldFinSizeS,
  xs: IconToolsHoldFinSizeS,
  name: 'IconToolsHoldFin',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
